import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { BarcodeScannerProvider } from './../../../providers/barcode-scanner-provider';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllKategoriler } from './../../../providers/bll/bll-kategoriler';
import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-toplu-fiyat-degistir',
  templateUrl: 'toplu-fiyat-degistir.html',
})
export class TopluFiyatDegistirPage {

  @ViewChild('sideNavUrunAra') sideNav;
  aranan = "";
  take: number = 50;
  UrunListesi = [];
  etiketListesi: any = { ETIKET_DETAYLARI: [] };
  aktarilanliste = [];
  KategoriListesi = [];
  secilenkategoriID: number = -1;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public toast: ToastController,
    public barcodeScanner: BarcodeScannerProvider) {
  }

  ionViewDidLoad() {

    this.UrunAra();
    this.KategoriGetir();
  }
  KategoriGetir() {
    var kategoriler = new BllKategoriler();
    kategoriler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(KategoriAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + "" + "%' or KategoriAdi='" + "" + "')" + " order by Sort").then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc;
      if (this.KategoriListesi == null || this.KategoriListesi.length == 0) {
        var formData = new FormData();
        formData.append("aranan", "");
        this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
          var sonuc = <any>a;
          this.KategoriListesi = sonuc.SonucObject;
        })
      }
    });

  }
  UrunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("katid", this.secilenkategoriID.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.UrunListesi = sonuc.SonucObject;
      this.closeNav();
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.UrunAra();
    }
  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
        position: 'top'
    });
    toast.present();
    // this.sonEklenen = mesaj;
  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.UrunAra();
    })
  }
  barkodara() {
    this.barcodeScanner.barkodOku().then(barcodeData => {

    }).catch(err => {
      console.log('Error', err);
    });
  }
alisfiyat(e,urun)
{
  if(e.keyCode==13)
  {
    var formdata=new FormData();
    formdata.append("stokid",urun.ID.toString());
    formdata.append("price1",urun.Price1.toString());
    formdata.append("price2",urun.Price2.toString());
    this.bllOrtak.islem(formdata,"TopluFiyatDegistir","",false).then(a=>{
      var sonuc=<any>a;
      if(sonuc.Sonuc==1)
      {
        var stoklarview = new BllViewStoklar();
        stoklarview.FiyatlariGuncelle(urun);
        this.presentToast(urun.StokAdi + "     " + "   " + "Fiyat Değiştirildi");
        this.UrunAra();
      }
      if(sonuc.Sonuc!=1)
      {
        this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
      }
    })
  }
}
satisfiyat(e,urun)
{
  if(e.keyCode==13)
  {
    var formdata=new FormData();
    formdata.append("stokid",urun.ID.toString());
    formdata.append("price1",urun.Price1.toString());
    formdata.append("price2",urun.Price2.toString());
    this.bllOrtak.islem(formdata,"TopluFiyatDegistir","",false).then(a=>{
      var sonuc=<any>a;
      if(sonuc.Sonuc==1)
      {
         var stoklarview = new BllViewStoklar();
         stoklarview.FiyatlariGuncelle(urun);
        this.presentToast(urun.StokAdi + "     " + "   " + "Fiyat Değiştirildi");
        this.UrunAra();
      }
      if(sonuc.Sonuc!=1)
      {
        this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
      }
    })
  }
}

  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {

    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";

  }

}


// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/toplu-fiyat-degistir/toplu-fiyat-degistir.ts